// Hazard subscore percentile rescale (#225).
//
// FEMA NRI raw scores cluster heavily 80-100 because most of our parcel
// footprint sits in regions where the underlying hazards (earthquake,
// wildfire, flood, heat, snow) are present. The 0-100 display axis
// therefore carries almost no information — every row reads "red."
//
// Per-metric breakpoints below come from the n=5,495,607 distribution
// pulled 2026-06-15 against feature_vectors (see #225 / #233 analysis
// comment). Each entry is [raw_value, percentile_rank]. rescaleByPercentile
// linearly interpolates within the table so a raw score of 80.8 earthquake
// (which is the population median) renders as 50, restoring usable
// contrast in the donut-breakdown row chips.
//
// Composite climate_risk_total_0_100 is intentionally NOT rescaled —
// its raw distribution (p05=29 → p95=78) already carries information.
//
// Per-state rescale could live here as a follow-up; for v1 we use the
// national distribution.
const PERCENTILE_TABLES = {
  flood:      [[0, 0], [11.0, 5], [38.8, 25], [69.6, 50], [89.2, 75], [96.8, 90], [98.5, 95], [100, 100]],
  wildfire:   [[0, 0], [0.0, 5], [45.5, 25], [72.0, 50], [93.7, 75], [98.3, 90], [99.2, 95], [100, 100]],
  hurricane:  [[0, 0], [1.1, 5], [15.6, 25], [30.1, 50], [49.4, 75], [73.3, 90], [84.6, 95], [100, 100]],
  earthquake: [[0, 0], [17.9, 5], [48.8, 25], [80.8, 50], [90.5, 75], [95.8, 90], [97.8, 95], [100, 100]],
  heat:       [[0, 0], [5.1, 5], [43.9, 25], [68.8, 50], [90.5, 75], [98.2, 90], [99.1, 95], [100, 100]],
  drought:    [[0, 0], [0.0, 5], [0.0, 25], [0.0, 50], [70.7, 75], [82.4, 90], [91.2, 95], [100, 100]],
  snow:       [[0, 0], [14.1, 5], [30.6, 25], [65.6, 50], [88.0, 75], [95.5, 90], [98.0, 95], [100, 100]],
  hail:       [[0, 0], [0.6, 5], [16.2, 25], [36.2, 50], [61.8, 75], [79.6, 90], [88.8, 95], [100, 100]],
};

export function rescaleByPercentile(raw, metric) {
  if (raw == null || Number.isNaN(raw)) return null;
  const table = PERCENTILE_TABLES[metric];
  if (!table) return raw;
  const x = Number(raw);
  if (x <= table[0][0]) return table[0][1];
  if (x >= table[table.length - 1][0]) return table[table.length - 1][1];
  for (let i = 1; i < table.length; i++) {
    const [x1, p1] = table[i];
    if (x <= x1) {
      const [x0, p0] = table[i - 1];
      const span = x1 - x0;
      if (span <= 0) return p1;
      const t = (x - x0) / span;
      return p0 + t * (p1 - p0);
    }
  }
  return table[table.length - 1][1];
}

export const HAZARD_PERCENTILE_METRICS = Object.keys(PERCENTILE_TABLES);
